/** 
 * Variant of N2StylesModal that binds a click handler to the specified
 * selector, that, when triggered, opens a modal indicated by the same selector
 * with -modal on the end.
 *
 * new N2StylesModalAuto(".js-my-feature")
 *
 * Adds click handler to open modal ".js-my-feature-modal"
 */

import N2StylesModal from './N2StylesModal'

export default class N2StylesModalAuto extends N2StylesModal {
  constructor(selector, opts={}) {
    super(selector, {skip_init: true});

    this.bindHandler(selector);
  }

  bindHandler(selector) {
    N2.handle("click", `${selector}`, () => {
      this.initModal(`${selector}-modal`);
    })
  }
}
